import PayslipDeductions from "../../../../components/company/pay-slip/deductions"

const PayslipDeductionsPage = () => {
    return <PayslipDeductions/>
}

export default PayslipDeductionsPage;